import React, { useEffect } from 'react'
import Notes from '../components/board/js/Notes'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

const NotesPage = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      if (location.pathname.startsWith("/notes")) {
        dispatch({ type: "GLOBAL_RESET" })
      }
    }
  }, [location, dispatch])

  return (
    <Notes/>
  )
}

export default NotesPage